/**
 * @generated SignedSource<<6b7232992f4bf7f60e062009dfbfe31e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreatePopupSetInput = {
  clientMutationId?: string | null;
  popupGroupSetId: string;
  name: string;
  memo?: string | null;
};
export type PopupSetCreateFormContainer_Mutation$variables = {
  input: CreatePopupSetInput;
  connections: ReadonlyArray<string>;
};
export type PopupSetCreateFormContainer_MutationVariables = PopupSetCreateFormContainer_Mutation$variables;
export type PopupSetCreateFormContainer_Mutation$data = {
  readonly createPopupSet: {
    readonly popupSetEdge: {
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly memo: string | null;
      } | null;
    };
  } | null;
};
export type PopupSetCreateFormContainer_MutationResponse = PopupSetCreateFormContainer_Mutation$data;
export type PopupSetCreateFormContainer_Mutation = {
  variables: PopupSetCreateFormContainer_MutationVariables;
  response: PopupSetCreateFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PopupSetEdge",
  "kind": "LinkedField",
  "name": "popupSetEdge",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PopupSet",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "memo",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupSetCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreatePopupSetPayload",
        "kind": "LinkedField",
        "name": "createPopupSet",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PopupSetCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreatePopupSetPayload",
        "kind": "LinkedField",
        "name": "createPopupSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "popupSetEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9c9f0d85e42568554fe4a156023e6562",
    "id": null,
    "metadata": {},
    "name": "PopupSetCreateFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation PopupSetCreateFormContainer_Mutation(\n  $input: CreatePopupSetInput!\n) {\n  createPopupSet(input: $input) {\n    popupSetEdge {\n      node {\n        id\n        name\n        memo\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f5b84c8060ce554c8e099626e060739";

export default node;
